// extracted by mini-css-extract-plugin
module.exports = {"InteractionBgCanvas":"InteractionBgCanvas-module--InteractionBgCanvas--31OEV"};